import { useEffect, useState } from 'react'
import * as React from 'react'

import PubSub from '@paytrace/pt-skel/Event/PubSub'
import { BatchTransactionOpResult } from '../types'
import Event from '../Event'
import { pastTenseEx } from '../Helper/BatchFeedback'

interface Props {
  action: string
  className?: string
}

export function BatchTransactionErrorFeedback (props: Props): React.ReactElement {
  const self = Symbol('BatchTransactionErrorFeedback')
  const [message, setMessage] = useState<React.ReactElement[]>([])

  useEffect(() => {
    PubSub.sub(
      self, Event.BATCH_TRANSACTION_ERROR_FEEDBACK,
      (json: {
        response: BatchTransactionOpResult[],
        records: { [key: string]: { preamble?: string, requested_amount: number } }
      }) => {
        const msg = json
          .response
          .map((row: BatchTransactionOpResult) => {
            const record = json.records[row.transaction_id]

            if (!record) {
              return ''
            }

            // Apparently, we have 3 variations that could have reasons
            // The array one is the most recent - the other 2 can probably leave
            // at some point.
            let processorError: string = ''

            // This reflects the new ErrorSchema array of errors stuff
            if (Array.isArray(row.data)) {
              processorError = row.data[0].detail
            } else {
              // TODO: Remove the conditionals when we feel confident we never
              // get this type of response.
              processorError = row.data.response_message || row.data.detail
            }

            const preamble = record.preamble ? record.preamble : `Transaction ID ${row.transaction_id}`

            return `${preamble} for
$${record.requested_amount.toFixed(2)} should be ${pastTenseEx(props.action)}.
However, the ${props.action} request was not successful per the response from the
processor: "${processorError}".`
          })
          .filter((msg: string) => msg.length > 0)

        // Don't show the wrapping div if we have no feedback
        if (msg.length > 0) {
          setMessage(msg.map((msg: string, i: number) => <div key={i}>{msg}<br /></div>))
        } else {
          setMessage([])
        }
      }
    )

    return () => {
      PubSub.unsub(self)
    }
  }, [self, props.action])

  const classes = 'error center error-feedback ' + (props.className || '')

  return message.length <= 0
    ? <React.Fragment />
    : <div className={classes}>{message}</div>
}
